var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-3 ma-10",attrs:{"tile":""}},[_c('v-card-title',[_vm._v(" ダッシュボード ")]),_c('v-data-table',{attrs:{"show-select":"","headers":_vm.status.headers,"items":_vm.status.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }